import React from 'react'
import PropTypes from 'prop-types'

import { cloud, text, semibold, titanium, Modal, mercury, purple, light, Checkbox } from '@rover/react-bootstrap'

import ColumnDisplay from './ColumnDisplay'

const modalContainer = {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
    height: 300,
    width: 251,
    overflow: 'scroll',
}

const segmentLine = {
    width: 210,
    height: 1,
    backgroundColor: mercury,
    marginBottom: 21,
    flex: '0 0 auto',
}

const ColumnDisplayContainer = ({
    updateChecked,
    showChecked,
    triggerColumnsMenu,
    pageClickLocation,
    showColumnsMenu,
    allColumns,
}) => {
    // Deep copy all columns so when we mutate it doesn't propagate
    const columns = allColumns.slice()

    // Strip userInfo & ticketmaster from labels
    columns.forEach(schema => {
        if (schema.selector === 'CUSTOM_DEVICE' && (schema.group === 'ticketmaster' || schema.group === 'userInfo')) {
            schema.label = schema.label.replace('userInfo.', '').replace('ticketmaster.', '')
        }
    })

    // Group columns by their group property
    const columnGroups = columns.reduce((acc, next) => {
        if (acc[next.group] === undefined) {
            acc[next.group] = []
        }
        acc[next.group].push(next)
        return acc
    }, {})

    return (
        <Modal
            isOpen={showColumnsMenu}
            onRequestClose={triggerColumnsMenu}
            contentLabel="Column Builder"
            style={{
                content: {
                    backgroundColor: 'white',
                    padding: 0,
                    width: 'auto',
                    bottom: null,
                    right: null,
                    top: pageClickLocation.y,
                    left: pageClickLocation.x,
                    transform: null,
                },
            }}
            hoverStyle={{
                backgroundColor: titanium,
            }}
            bodyOpenClassName="bodyClassName"
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: 50,
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 20,
                    backgroundColor: cloud,
                    ...text,
                    ...semibold,
                }}
            >
                Display these columns
            </div>

            <div
                style={{
                    margin: 0,
                    marginTop: 20,
                    marginLeft: 20,
                }}
            >
                <div style={modalContainer}>
                    {Object.keys(columnGroups).map((group, index, arr) => (
                        <div key={group}>
                            <ColumnDisplay
                                selector={group}
                                items={columnGroups[group]}
                                updateChecked={updateChecked}
                                showChecked={showChecked}
                            />
                            {index != arr.length - 1 && <div style={segmentLine} />}
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    )
}

ColumnDisplayContainer.propTypes = {
    showColumnsMenu: PropTypes.bool.isRequired,
    updateChecked: PropTypes.func.isRequired,
    showChecked: PropTypes.func.isRequired,
    triggerColumnsMenu: PropTypes.func.isRequired,
    pageClickLocation: PropTypes.object.isRequired,
    allColumns: PropTypes.arrayOf(
        PropTypes.shape({
            attribute: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            __typename: PropTypes.string.isRequired,
            selector: PropTypes.string.isRequired,
            group: PropTypes.string.isRequired,
        })
    ).isRequired,
}

ColumnDisplayContainer.defaultProps = {
    showColumnsMenu: false,
    updateChecked: () => null,
    showChecked: () => null,
    triggerColumnsMenu: () => null,
    pageClickLocation: {
        x: 0,
        y: 0,
    },
    allColumns: [],
}

export default ColumnDisplayContainer
